module.exports = __webpack_public_path__ + "static/media/mountain-grid.98d92681.svg";